import { generateResourceReducer } from '../generators/resource.reducer';

import * as constants from './session-transcript-summary.constants';
import * as types from './session-transcript-summary.types';

export const sessionTranscriptSummaryReducer = generateResourceReducer<types.ISessionTranscriptSummary>({
  STORE: constants.STORE_SESSION_TRANSCRIPT_SUMMARY,
  CLEAR: constants.CLEAR_SESSION_TRANSCRIPT_SUMMARY,
});
